var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import CollapsedTable from 'components/shared/tables/collapsedTable/component';
import { useTransactionTableConfig } from 'components/configs/collapseTable/transactionTable/TransactionTableConfig';
import { useAutoOpenedGameStage, getCurrentlyActiveState } from 'helpers/stageUtilities';
import MobCollapseTable from 'components/shared/tables/mobCollapseTable/component';
import { useMobTransactionTableConfig } from 'components/configs/collapseTable/transactionTable/MobTransactionTableConfig';
export default function Transactions(_a) {
    var _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.currentAccount, currentAccount = _c === void 0 ? '' : _c;
    var player = useSelector(function (state) { return state.player; });
    var game = useSelector(function (state) { return state.game; });
    var rawPlayers = useSelector(function (state) { return state.general.players; });
    var rawCompanies = useSelector(function (state) { return state.general.companies; });
    var playersAndCompanies = useMemo(function () { return __spreadArray(__spreadArray([], rawPlayers, true), rawCompanies, true); }, [rawPlayers, rawCompanies]);
    var stages = useSelector(function (state) { return state.game.stages; });
    var currentlyActiveState = getCurrentlyActiveState(stages);
    var presetTransactions = player.transactions || [];
    var company = { transactions: player.company.transactions || [] };
    var _d = useState([]), openRowIds = _d[0], setOpenRowIds = _d[1];
    var transactions = type === 'company' ? company.transactions : presetTransactions;
    useAutoOpenedGameStage(currentlyActiveState, setOpenRowIds);
    function onExtensionClick(id) {
        var newIdsArray = __spreadArray([], openRowIds, true);
        var idx = newIdsArray.findIndex(function (presentId) { return presentId === id; });
        if (idx !== -1) {
            newIdsArray.splice(idx, 1);
        }
        else {
            newIdsArray.push(id);
        }
        setOpenRowIds(newIdsArray);
    }
    var tablesProperties = useMemo(function () { return ({
        transactions: transactions,
        game: game,
        playersAndCompanies: playersAndCompanies,
        openRows: openRowIds,
        onItemClick: function (id) { return onExtensionClick(id); },
        currentAccount: currentAccount || (type === 'company' ? player.company.id : player.id)
    }); }, [transactions, game, playersAndCompanies, openRowIds, type, currentAccount, player.company.id, player.id]);
    var tableConfig = useTransactionTableConfig(__assign({}, tablesProperties));
    var mobileTableConfig = useMobTransactionTableConfig(tableConfig);
    return (React.createElement("div", { className: "transactions" },
        React.createElement("div", { className: "d-none d-block-md" },
            React.createElement(CollapsedTable, { tableWrapperClasses: "collapse-table--last-icons collapse-table--side-paddings", groups: tableConfig })),
        React.createElement("div", { className: "d-none-md" },
            React.createElement(MobCollapseTable, { onExtensionClick: onExtensionClick, config: mobileTableConfig }))));
}
